import { pick } from 'underscore';

const whitelistedSchemaPropertyKeysForModel = [
  'ParentId', 'Id', 'Name', 'Status', 'AdGroupType', 'Language',
];

export const viewModelToModelForAdGroup = adGroupViewModel => ({
  ...pick(adGroupViewModel, whitelistedSchemaPropertyKeysForModel),
});

export const bulkModelToViewModelForAdGroup = ({
  adGroupModel,
  originalAdGroupModel,
}) => {
  const data = {
    ...originalAdGroupModel,
    ...pick(adGroupModel, whitelistedSchemaPropertyKeysForModel),
  };

  return data;
};

export const modelToViewModelForAdGroup = (adGroupModel) => {
  const viewModel = {
    ...pick(adGroupModel, whitelistedSchemaPropertyKeysForModel),
  };

  return viewModel;
};
